// DealfioulBanner.js
import React from 'react';
import './DealfioulBanner.css';

const DEALFUEL_URL = 'https://www.dealfuel.com/seller/book-witch-ai-book-writer/';

const DealfioulBanner = () => {
    return (
        <div className="section dealfioul-banner" role="region" aria-label="DealFuel lifetime deal banner">
            <div className="dealfioul-banner__inner">
                <div className="dealfioul-banner__logo">
                    <img
                        src="/new-df-header-logo.png"
                        alt="DealFuel"
                        width="175"
                        height="52"
                        loading="lazy"
                    />
                </div>
                <div className="dealfioul-banner__content">
                    <div className="dealfioul-banner__badge">Lifetime Deal</div>
                    <h3 className="dealfioul-banner__title">Get Book Witch for life — one-time payment</h3>
                    <p className="dealfioul-banner__text">
                        We are featured on DealFuel. Secure lifetime access to Book Witch with all core
                        features, updates, and unlimited creativity. Limited-time offer, limited coupons.
                    </p>
                    <div className="dealfioul-banner__actions">
                        <a href={DEALFUEL_URL} target="_blank" rel="noopener noreferrer" className="no-style-link">
                            <button className="button-important">
                                <div className="inner">View the Deal</div>
                            </button>
                        </a>
                        <span className="dealfioul-banner__note">30-day guarantee • Pay once, use forever</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DealfioulBanner;


